import { QuestionTable } from '@cureskin/api-client/src/table/question';
import { ChatChannel } from '@services/chat-service/chat-service.types';

/**
 * A chat row the generic quiz layer drives. The shared Parse `ChatMessage` base — every concrete
 * chat table (ConsultationSessionChat, FollowUpChat, SupportChat, …) is built from its attributes
 * and assignable to it, so the layer reads common fields with real `.get` typing; domain code that
 * needs table-specific fields (e.g. ConsultationSessionChat.showAfterTime) narrows to that table.
 */
export type QuizChatMessage = Table.ChatMessage;

/** Single entry of a question's Inputs array (server-side imageUrl augmentation, same as legacy ChatInput). */
export type QuizOption = QuestionTable['attributes']['inputs'][number] & {
  params: { imageUrl?: string; actionName?: string; queryParams?: string };
};

export const QuizAnswerOutcome = {
  Sent: 'sent',
  Ignored: 'ignored',
} as const;
export type QuizAnswerOutcome = typeof QuizAnswerOutcome[keyof typeof QuizAnswerOutcome];

export const QuizQuestionLayout = {
  SingleSelect: 'single-select',
  MultiSelect: 'multi-select',
  Text: 'text',
  PhotoUpload: 'photo-upload',
} as const;
export type QuizQuestionLayout = typeof QuizQuestionLayout[keyof typeof QuizQuestionLayout];

/** actionName dispatched by SingleSelectorService.openInAppAction to open the camera/instruction flow. */
export const INSTANT_CHECKUP_ACTION_NAME = 'InstantCheckup';
export const MULTI_SELECT_SEPARATOR = '|||';

export interface QuizChatConfig {
  channel: ChatChannel;
  isCompletionMessage: (message: QuizChatMessage) => boolean;
  skipQuestionIds: string[];
  resumeNudge?: () => Promise<void>;
  onMessages?: (newMessages: QuizChatMessage[]) => void;
}
